import { FormControl, FormGroup, Validators } from '@angular/forms';
import { map } from 'rxjs/operators';
import { AlertType } from 'src/app/models/price-alert';
import { CustomValidators } from 'src/app/validators/custom-validators';
import { AlertForm } from './alert-form';
import { FormValidators } from 'src/app/validators/form-validators';

export class PercentageDecreaseAlertForm extends AlertForm {
  controlName = AlertType.PERCENTAGE_DECREASE;
  control = new FormControl(
    null,
    [Validators.required, CustomValidators.integerValidator, FormValidators.greaterThanZero]
  );

  private _valueChangeSubscription;

  public toFormGroup(formGroup: FormGroup): FormGroup {

    this._valueChangeSubscription = this.control.valueChanges.pipe(map((val: string) => {
      const parsedValue = parseInt(val);
      if(!parsedValue) return;
      
      this.control.setValue(parsedValue, {emitEvent: false});
    })).subscribe();

    return super.toFormGroup(formGroup);
  }

  clearControl(formGroup): FormGroup {
    this._valueChangeSubscription.unsubscribe();
    return super.clearControl(formGroup);
  }
}
